import status from "./documentRouteStatus";

export default [
  { id: status.Sent, name: "Sent", color: "primary", icon: "mdi-send" },
  { id: status.Received, name: "Received", color: "primary", icon: "mdi-check" },
  { id: status.Approved, name: "Approved", color: "success" },
  { id: status.Paid, name: "Paid", color: "success", icon: "mdi-currency-usd" },
  { id: status.Rejected, name: "Rejected", color: "error", icon: "mdi-alert-circle-outline" },
  { id: status.Resubmitted, name: "Resubmitted", color: "primary", icon: "mdi-refresh" },
  { id: status.New, name: "New", color: "primary", icon: "mdi-new-box" },
  { id: status.Pending, name: "Pending", color: "primary", icon: "mdi-clock-outline" },
  { id: status.Returned, name: "Returned", color: "primary", icon: "mdi-restore" },
  { id: status.Viewed, name: "Viewed", color: "success", icon: "mdi-eye" },
  { id: status.Recalled, name: "Recalled", color: "warning", icon: "mdi-undo" },
];
